import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import TopRatedSchool from "./TopRatedSchool";
import HappyStudentsCollaboratedWith from "./HappyStudentsCollaboratedWith";
import ForStudentsParentsTeachersSchools from "./ForStudentsParentsTeachersSchools";
import HowItWorks from "./HowItWorks";
import Feature from "./Feature";
import LearnerTestimonial from "./LearnerTestimonial";
import FormField from "./FormField";
import Header from "./Header";
import Footer from "./Footer";
import "./css/new_landing_page.css";
import BookDemo from "./BookDemo";
import { apiUrl } from "../../../http-common";
import "./css/book_demo.css";
import "./css/get_in_touch.css";
import { emailRegex } from "../utility_functions";
import FeatureAtAGlance from "./FeatureAtAGlance";

const NewLandingPage = () => {
  const [schoolSearchResults, setSchoolSearchResults] = useState([]);
  const [sampleSchools, setSampleSchools] = useState([]);
  const [topRatedSchools, setTopRatedSchools] = useState([]);
  const [allFeatures, setAllFeatures] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchDistrictTerm, setSearchDistrictTerm] = useState("");
  const [allSchoolsData, setAllSchoolsData] = useState([]);
  const [headerBackgroundImageURL, setHeaderBackgroundImageURL] = useState(
    "./new_landing_page_images/school_hero_1.png"
  );

  const [hasPickedDate, setHasPickedDate] = useState(false);
  const [
    hasSubmittedGetInTouchSuccessfully,
    setHasSubmittedGetInTouchSuccessfully,
  ] = useState(false);
  const [showLoadingGetInTouch, setShowLoadingGetInTouch] = useState(false);
  const [isLoadingGetInTouch, setIsLoadingGetInTouch] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [formatedSelectedDate, setFormatedSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("10:00am");
  const demo_times = ["10:00am", "11:00am", "01:00pm", "02:30pm", "04:00pm"];
  const [payloadGetInTouch, setPayloadGetInTouch] = useState({});
  const [isNameValidGetInTouch, setIsNameValidGetInTouch] = useState(true);
  const [isEmailValidGetInTouch, setIsEmailValidGetInTouch] = useState(true);
  const [isPhoneNumberValidGetInTouch, setIsPhoneNumberValidGetInTouch] =
    useState(true);
  const [
    isInstitutionNameValidGetInTouch,
    setIsInstitutionNameValidGetInTouch,
  ] = useState(true);
  const [isRoleValidGetInTouch, setIsRoleValidGetInTouch] = useState(true);
  const [isMessageGetInTouch, setIsMessageGetInTouch] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [
    "/new_landing_page_images/hero1.png",
    "/new_landing_page_images/hero2.png",
    "/new_landing_page_images/hero3.png",
  ];

  const SLIDE_DURATION = 1200;
  const PAUSE_DURATION = 2800;
  const TRANSITION_DELAY = 1000;
  const LAST_SLIDE_EXTRA_DELAY = 700
  const LAST_SLIDE_WAIT = SLIDE_DURATION + PAUSE_DURATION + TRANSITION_DELAY + LAST_SLIDE_EXTRA_DELAY;
  const [activeBgImageIndex, setActiveBgImageIndex] = useState(0);
  const [transitionDuration, setTransitionDuration] = useState(
    `${SLIDE_DURATION}ms`
  );
  const [indicatorWidth, setIndicatorWidth] = useState(0);

  useEffect(() => {
    const delay = activeBgImageIndex === images.length - 1 ? LAST_SLIDE_WAIT : SLIDE_DURATION + PAUSE_DURATION + TRANSITION_DELAY;
 
    if (activeBgImageIndex === 0) {
      setIndicatorWidth(0);
      setTimeout(() => setIndicatorWidth(100), PAUSE_DURATION);
    } else {
       
      setIndicatorWidth(0);
      setTimeout(() => setIndicatorWidth(100), PAUSE_DURATION);
    }

    const interval = setTimeout(() => {
      if (activeBgImageIndex === images.length - 1) {
        setTimeout(() => setActiveBgImageIndex(0), SLIDE_DURATION);  
      } else {
        setTransitionDuration(`${SLIDE_DURATION}ms`);
        setTimeout(() => setActiveBgImageIndex((prev) => prev + 1), SLIDE_DURATION);  
      }
    }, delay);

    return () => clearTimeout(interval);
  }, [activeBgImageIndex, images.length]);

  useEffect(function loadAllSchoolsData() {
    const fetchSchools = async () => {
      try {
        const response = await fetch(
          `${apiUrl}institutions/schools-list/
`,
          { method: "GET" }
        );

        const reduced_response = response.json();
        reduced_response.then((data) => {
          setAllSchoolsData(
            data
            // .filter(
            //   (school) =>
            //     (school?.institution_name?.toLowerCase()?.includes("") &&
            //       school?.institution_name?.toLowerCase()?.includes("high")) ||
            //     (school?.institution_name?.toLowerCase()?.includes("") &&
            //       school?.institution_name?.toLowerCase()?.includes("high")) ||
            //     (school?.institution_name?.toLowerCase()?.includes("") &&
            //       school?.institution_name?.toLowerCase()?.includes("high")) ||
            //     (school?.institution_name?.toLowerCase()?.includes("") &&
            //       school?.institution_name?.toLowerCase()?.includes("1"))
            // )
          );
        });
      } catch (error) {
        console.log("Error");
      }
    };
    fetchSchools();
  }, []);

  useEffect(
    function loadSampleSchools() {
      setSampleSchools(allSchoolsData);
    },
    [allSchoolsData]
  );

  function filterInstitutions(data, query) {
    query = query.toLowerCase();

    return data.filter((institution) => {
      return Object.values(institution).some((value) => {
        if (typeof value === "string") {
          return value.toLowerCase().includes(query);
        } else if (Array.isArray(value)) {
          return value.some(
            (item) =>
              typeof item === "string" && item.toLowerCase().includes(query)
          );
        } else if (typeof value === "object" && value !== null) {
          return Object.values(value).some(
            (innerValue) =>
              typeof innerValue === "string" &&
              innerValue.toLowerCase().includes(query)
          );
        }
        return false;
      });
    });
  }

  useEffect(function loadTopRatedSchools() {
    setTopRatedSchools([
      {
        institution_name: "Pamushana High School",
        institution_district: "Bikita District",
        institution_distance: "316KM",
        rating: "4.7",
        url: "/school_details/10",
        banner: "./new_landing_page_images/pamushana.jpg",
        school_brief_description:
          "Pamushana High School, located in Bikita District, is a highly rated institution. Situated 316 km from Harare, it offers a strong academic environment. Known for its dedicated staff and a focus on both academic and personal growth, the school serves as a cornerstone of education in the region. Its remote location fosters a close-knit community, and students benefit from a well-rounded education. Pamushana High continues to build a reputation for excellence, preparing students for future success.",
      },
      {
        institution_name: "Kwenda High School",
        institution_district: "Hwedza District",
        institution_distance: "172KM",
        rating: "4.8",
        url: "/school_details/62",
        banner: "./new_landing_page_images/kwenda_1.jpg",
        school_brief_description:
          "Kwenda High School, located in Hwedza District, is a vibrant educational institution committed to nurturing academic excellence and personal growth. The school offers a well-rounded curriculum, emphasizing both academic subjects and extracurricular activities to ensure students’ holistic development",
      },
      {
        institution_name: "Langham Girls High School",
        institution_district: "Mazowe District",
        institution_distance: "91KM",
        rating: "4.7",
        url: "/school_details/1",
        banner: "./new_landing_page_images/langham_1.jpg",
        school_brief_description:
          "Langham Girls High School, situated in Mazowe District, is a premier institution dedicated to empowering young women through education. The school provides a robust academic curriculum complemented by a range of extracurricular activities aimed at developing leadership, creativity, and confidence",
      },
      {
        institution_name: "Chemhanza High School",
        institution_district: "Hwedza District",
        institution_distance: "135KM",
        rating: "4.5",
        url: "/school_details/63",
        banner: "./new_landing_page_images/chemhanza_1.jpg",
        school_brief_description:
          "Chemhanza High School, located in Hwedza District, is a dynamic educational institution focused on academic excellence and character development. The school offers a wide range of subjects, ensuring that students receive a comprehensive education while fostering critical thinking and problem-solving skills. ",
      },
    ]);
  }, []);

  const happy_students_img_urls = [
    "./new_landing_page_images/happy_student_1.png",
    "./new_landing_page_images/happy_student_2.png",
    "./new_landing_page_images/happy_student_3.png",
    "./new_landing_page_images/happy_student_4.png",
    "./new_landing_page_images/happy_student_5.png",
  ];

  const schools_collaborated_with_img_urls = [
    "./new_landing_page_images/Pamushana_High_School.png",
    "./new_landing_page_images/St_Philips_High_Magwenya.svg",
    "./new_landing_page_images/Langham_Girls_High_School.svg",
    "./new_landing_page_images/St_Francis_&_St_Clare.svg",
    "./new_landing_page_images/St_Johns_Chikwaka.svg",
  ];

  const whyBrainstake = {
    for_students: {
      heading: "Parents' Mobile App",
      icon_url: "./new_landing_page_images/for_students.svg",
      content: [
        "Access coursework and track progress.",
        "View exam schedules and reminders.",
        "Explore a digital e-library.",
        "Stay updated on homework and notices.",
        "Check grades and results in one place.",
        "Tailored for students of all levels.",
      ],
      make_green: false,
    },
    for_teachers: {
      heading: "Administration Mobile App",
      icon_url: "./new_landing_page_images/for_teachers.svg",
      content: [
        "Organize task allocations easily.",
        "Streamline communication with students.",
        "Connect with parents effectively.",
        "Access coursework tools quickly.",
        "Share announcements effortlessly.",
        "Manage schedules with ease.",
      ],
      make_green: false,
    },
    for_parents: {
      heading: "Parents' Portal",
      icon_url: "./new_landing_page_images/for_parents.svg",
      content: [
        "Real-time updates on performance.",
        "Get disciplinary reports.",
        "Access exam results and timetables.",
        "View school payment details.",
        "Communicate with teachers and staff easily.",
      ],
      make_green: false,
    },
    for_schools: {
      heading: "Teachers' Portal",
      icon_url: "./new_landing_page_images/new_for_schools.png",
      content: [
        "Manage student records easily.",
        "Keep teacher records organized.",
        "Connect with parents quickly.",
        "Communicate with staff seamlessly.",
        "Simplify tuition payments.",
        "Streamline fee collection.",
      ],
      make_green: false,
    },
  };

  const howItWorksData = [
    {
      icon_url: "./new_landing_page_images/sign_up_and_create_profiles.svg",
      heading: "Sign Up & Create Profiles",
      content:
        "Students, parents, teachers, and schools can easily onboard with tailored workflows.",
    },
    {
      icon_url: "./new_landing_page_images/organize_and_access.svg",
      heading: "Organize & Access",
      content:
        "Centralized access to academic schedules, performance reports, communication tools, and payment information",
    },
    {
      icon_url: "./new_landing_page_images/learn_and_grow.svg",
      heading: "Learn and Grow",
      content:
        "Access the e-library, manage tasks, and streamline school management—all under one platform.",
    },
  ];

  const learnersTestimonials = [
    {
      heading: "Accurate Parent Feedback!",
      content:
        "The platform has allowed me to have direct contact with my student's parents and guardians. It's become that much easier to understand how I can teach them best.",
      testifier_name: "",
      testifier_role: "Teacher",
      media_type: "image",
      media_url: "./new_landing_page_images/testifier1.png",
    },
    {
      heading: "Data processing and analysis",
      content:
        "The fact that it automatically compiles and processes data to create student progress charts and highlights areas of improvement just.",
      testifier_name: "Talent K",
      testifier_role: "Web Designer",
      media_type: "video",
      media_url: "./new_landing_page_videos/hero.mp4",
    },
    {
      heading: "Highly recommend!",
      content:
        "I have been in the education sector for 2 decades and this is one of those tools I never thought I needed until I had it at my disposal",
      testifier_name: "H. Guyo",
      testifier_role: "School Administrator H.O.D",
      media_type: "image",
      media_url: "./new_landing_page_images/testifier2.png",
    },
  ];

  useEffect(function displayFeatures() {
    const all_features = [
      {
        img_url: "/new_landing_page_images/student_studying.png",
        heading: "Student Information System",
        content:
          "Stay organized with dashboards tailored for students, showing coursework, exam schedules, and progress reports.",
      },
      {
        img_url:
          "/new_landing_page_images/school_admininistrator_in_office.png",
        heading: "School Admin Management System",
        content:
          "Simplify school operations with tools to manage student and teacher data, meetings, payments, and announcements.",
      },
      {
        img_url: "/new_landing_page_images/father_with_daughter.png",
        heading: "Parent Management System",
        content:
          "Get real-time updates about your child’s performance, disciplinary records, and payments.",
      },
      {
        img_url: "/new_landing_page_images/girl_in_library.png",
        heading: "e-Library system",
        content:
          "Access a vast digital library anytime, anywhere—browse e-books, research materials, and academic resources with ease.",
      },
      {
        img_url: "/new_landing_page_images/woman_with_laptop.png",
        heading: "Safe & Secure payment for Parents",
        content:
          "We ensure encrypted transactions and multiple payment options for a smooth and worry-free experience.",
      },
      {
        img_url: "/new_landing_page_images/young_girl_with_vr.png",
        heading: "Advanced Course Management tools",
        content:
          "Streamline scheduling, track progress, and optimize learning experiences with ease.",
      },
    ];
    setAllFeatures(all_features);
  }, []);

  const [shownFeatures, setShownFeatures] = useState(allFeatures.slice(0, 3));
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    setShownFeatures(allFeatures.slice(0, 3));
  }, [allFeatures]);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setIndex((prevIndex) => (prevIndex === 0 ? 1 : 0));
        setShownFeatures(
          allFeatures.slice(index === 0 ? 3 : 0, index === 0 ? 6 : 3)
        );
        setFade(true);
      }, 300);
    }, 7000);

    return () => clearInterval(interval);
  }, [index, allFeatures]);

  async function getInTouch() {
    setShowLoadingGetInTouch(true);
    setIsLoadingGetInTouch(true);
    const response = await fetch(
      `${apiUrl}institutions/get-in-touch
`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payloadGetInTouch),
      }
    );

    const reduced_response = await response.json();
    // console.log("Response", reduced_response.institution_name);
    if (reduced_response?.institution_name?.length > 0) {
      setTimeout(() => {
        setHasSubmittedGetInTouchSuccessfully(true);
        setIsLoadingGetInTouch(false);
      }, 2000);
    } else {
      setTimeout(() => {
        setIsLoadingGetInTouch(false);
        setHasSubmittedGetInTouchSuccessfully(false);
      }, 2000);
    }
  }

  const features_at_a_glance = [
    "BrainPay",
    "Accounting",
    "E-Library",
    "E-Reports",
    "HR & Payroll",
    "Online Payments",
    "Procurement",
  ];

  const sample_schools_with_logos = [
    {
      school_name: "Pamushana High School",
      logo_url: "./new_landing_page_images/pamushana.png",
    },
    {
      school_name: "St Philips High Mangwenya",
      logo_url: "./new_landing_page_images/st_philips_chingwenya.png",
    },
    {
      school_name: "Langham Girls High School",
      logo_url: "./new_landing_page_images/langham.png",
    },
    {
      school_name: "St Francis & St Clare",
      logo_url: "./new_landing_page_images/st_francis_st_clare.png",
    },
    {
      school_name: "St Johns Chikwaka",
      logo_url: "./new_landing_page_images/st_johns_chikwaka.png",
    },
    {
      school_name: "Mt Melleray School",
      logo_url: "./new_landing_page_images/mt_melleray.png",
    },
    // {
    //   school_name: "Langham Girls High School",
    //   logo_url: "./new_landing_page_images/langham.png",
    // },
  ];

  useEffect(() => {
    if (sampleSchools.length > 0) {
      setHeaderBackgroundImageURL(sampleSchools[currentIndex].banner);
    }
  }, [currentIndex, sampleSchools, setHeaderBackgroundImageURL]);

  return (
    <div className="new_landing_page">
      <div
        className={`get_in_touch_submission${
          showLoadingGetInTouch ? "" : " displayed_none"
        }`}
      >
        <div className="main_container">
          <button
            className="close_modal"
            onClick={() => {
              // document
              //   .querySelector(".get_in_touch_submission")
              //   .classList.toggle("displayed_none");
              setShowLoadingGetInTouch(false);
            }}
          ></button>
          {showLoadingGetInTouch &&
            (isLoadingGetInTouch ? (
              <div
                className="demo_request_submission_status loading"
                style={{
                  backgroundImage: `url("/new_landing_page_images/loader.gif")`,
                  backgroundSize: "150px auto",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                }}
              >
                <h3>Please wait while your info is being submitted</h3>
              </div>
            ) : (
              <div
                className="demo_request_submission_status"
                style={{
                  backgroundImage: `url("/new_landing_page_images/${
                    hasSubmittedGetInTouchSuccessfully
                      ? "demo_submission_success.svg"
                      : "demo_submission_failure.png"
                  }")`,
                  backgroundSize: "96px 96px",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center 30px",
                }}
              >
                <h3>
                  {hasSubmittedGetInTouchSuccessfully
                    ? "Congratulations!"
                    : "An error occurred"}
                </h3>
                <p>
                  {hasSubmittedGetInTouchSuccessfully
                    ? "Your infomation has been submitted successfully."
                    : "Something went wrong while submitting your info. Please try again"}
                </p>
              </div>
            ))}
        </div>
      </div>

      <div className="header">
        <div
          className="background_container"
          style={{
            transform: `translateX(-${activeBgImageIndex * 100}%)`,
            transition: `transform ${transitionDuration} ease-in-out`,
          }}
        >
          {images.map((image, index) => (
            <div
              key={index}
              className="background_slide"
              style={{
                backgroundImage: `url(${image})`,
              }}
            ></div>
          ))}
        </div>
        <Header />
        <div className="hero">
          <div className="hero_left">
            <h1>THE DIGITAL HUB FOR EVERY SCHOOL</h1>
            <div className="middle">
              <div className="search_for_school">
                <input
                  type="text"
                  value={searchTerm}
                  name="institution_name"
                  id="institution_name"
                  placeholder="Enter School Name or Code"
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                  }}
                />
                <input
                  type="text"
                  value={searchDistrictTerm}
                  name="location"
                  id="location"
                  placeholder="Enter City or Region"
                  onChange={(e) => {
                    setSearchDistrictTerm(e.target.value);
                  }}
                />
                <button
                  className="search"
                  onClick={() => {
                    if (searchTerm) {
                      setSchoolSearchResults(
                        filterInstitutions(allSchoolsData, searchTerm)
                      );
                    } else if (searchDistrictTerm) {
                      setSchoolSearchResults(
                        filterInstitutions(allSchoolsData, searchDistrictTerm)
                      );
                    } else {
                      setSchoolSearchResults([]);
                    }
                  }}
                >
                  Search
                </button>
                <div
                  className={`search_results ${
                    schoolSearchResults.length > 0 &&
                    (searchTerm.length > 0 || searchDistrictTerm.length > 0)
                      ? ""
                      : " displayed_none"
                  }`}
                >
                  {schoolSearchResults.length > 0 &&
                    (searchTerm.length > 0 || searchDistrictTerm.length > 0) &&
                    schoolSearchResults.map((search_result, index) => (
                      <Link
                        key={index}
                        to={`/school_details/${search_result?.tenant_id}`}
                        target="_blank"
                      >
                        <span>{search_result.institution_name}</span>
                        <div className="right">
                          <span>{search_result.institution_district}</span>
                          {/* <span>
                          {search_result.institution_distance}&nbsp;Away
                        </span> */}
                        </div>
                      </Link>
                    ))}
                  <Link
                    className="see_all"
                    to={`/school_search_results?query=${searchTerm}&location=${searchDistrictTerm}`}
                    target="_blank"
                  >
                    See All
                  </Link>
                </div>
              </div>
              <p className="you_are_connected">
                YOU ARE CONNECTED TO YOUR SCHOOL
              </p>
              <p className="what_we_offer_you">
                <span>YOUR CONVENIENCE</span>
                <span>&nbsp;|&nbsp;</span>
                <span>E-REPORTS</span>
                <span>&nbsp;|&nbsp;</span>
                <span>E-STATEMENTS</span>
                <span>&nbsp;|&nbsp;</span>
                <span>E-LIBRARY</span>
                <span>&nbsp;|&nbsp;</span>
                <span>E-LEARNING</span>
                <span>&nbsp;|&nbsp;</span>
                <span>BRAINPAY</span>
              </p>
            </div>
            <div className="slider_container">
        {images.map((_, index) => (
          <button
            key={index}
            className={`slider_button ${index === activeBgImageIndex ? "active_bg" : ""}`}
          >
            <span
              className="slider_indicator"
              style={{
                width: index === activeBgImageIndex ? `${indicatorWidth}%` : "0%",  
                transition: `width ${index === activeBgImageIndex ? PAUSE_DURATION / 1000 : 0}s ease-in-out`,
              }}
            ></span>
          </button>
        ))}
      </div>
          </div>
          <div className="hero_right"></div>
        </div>
      </div>
      <div className="sample_schools_with_logos">
        {sample_schools_with_logos?.map(({ school_name, logo_url, index }) => (
          <div key={index} className="school_name_with_logo">
            <img src={logo_url} alt={`${school_name}_logo`} />
            <h3>{school_name}</h3>
          </div>
        ))}
      </div>
      <div className="top_rated_schools_container">
        <h2>
          <span>Top Rated Schools</span>
          <div className="right">
            <Link
              to={`/school_search_results?query=${"a"}&location=${""}`}
              target="_blank"
            >
              See All
            </Link>
            {/* <button className="scroll_left"></button>
            <button className="scroll_right"></button> */}
          </div>
        </h2>
        <div className="top_rated_schools">
          {topRatedSchools.length > 0 &&
            topRatedSchools.map(
              (
                {
                  rating,
                  institution_name,
                  institution_district,
                  banner,
                  url,
                  school_brief_description,
                },
                index
              ) => (
                <TopRatedSchool
                  key={index}
                  rating={rating}
                  name={institution_name}
                  district={institution_district}
                  banner={banner}
                  url={url}
                  school_brief_description={school_brief_description}
                  index={index}
                />
              )
            )}
        </div>
      </div>
      <div className="why_all_in_one_place">
        <h2>
          <span>Why E-schools?</span>
          <span>All in one place</span>
        </h2>
        <div className="features_a_at_a_glance">
          {features_at_a_glance?.map((feature, index) => (
            <FeatureAtAGlance key={index} content={feature} />
          ))}
        </div>
      </div>
      <div className="why_brainstake_eschools1">
        <div className="for_students_parents_teachers_schools1">
          <div className="right">
            <HappyStudentsCollaboratedWith
              images={happy_students_img_urls}
              heading={"Our Happy Students"}
              message={"1000+ Online Users"}
              number={0}
            />
          </div>
          <div className="left">
            {Object.keys(whyBrainstake).map((why, index) => (
              <ForStudentsParentsTeachersSchools
                key={index}
                icon_url={whyBrainstake[why].icon_url}
                heading={
                  index === 0
                    ? "Students Mobile App"
                    : index === 1
                    ? "Teachers Mobile App"
                    : index === 2
                    ? "Student Portal"
                    : "Teacher's Portal"
                }
                content={whyBrainstake[why].content}
                make_green={whyBrainstake[why].make_green}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="sample_modules">
        <div className="slider_btn_container left_slider_btn_container">
          <button
            className="left_slider_btn"
            onClick={(e) => {
              e.target.parentElement.parentElement.parentElement
                .querySelector(".school_admin_module")
                .classList.toggle("displayed_none");
              e.target.parentElement.parentElement.parentElement
                .querySelector(".school_accounts_module")
                .classList.toggle("displayed_none");
            }}
          ></button>
        </div>
        <div className="sample_modules_module school_admin_module">
          <div className="left">
            <h2>School Admin Module</h2>
            <ul>
              <li>Manage student records easily.</li>
              <li>Keep teacher records organized.</li>
              <li>Connect with parents quickly.</li>
              <li>Communicate with staff seamlessly.</li>
              <li>Simplify tuition payments.</li>
              <li>Streamline fee collection.</li>
            </ul>
            <button
              className="book_a_demo"
              onClick={() =>
                document
                  .querySelector(".book_demo_container")
                  .classList.toggle("displayed_none")
              }
            >
              Book a Demo
            </button>
          </div>
          <div className="right">
            <div className="bg_img_container"></div>
            <div className="monitor_course_fees">
              <h3>Monitor Course Fees</h3>
              <p>
                <img
                  src="./new_landing_page_images/monitor_course_fees_icon.svg"
                  alt="monitor_course_fees"
                />
                <span>Secure Payment</span>
              </p>
            </div>
          </div>
        </div>
        <div className="sample_modules_module school_accounts_module displayed_none">
          <div className="left">
            <h2>School Accounts Module</h2>
            <p className="content">
              Welcome to a place where you no longer have to worry about missing
              accounts or costly errors. With our suite of powerful tools,
              designed in collaboration with expert accountants, you gain the
              best software to manage your school’s finances with ease.
              Everything your administration team needs for smooth, accurate
              accounting is right at your fingertips.
            </p>
            <button
              className="book_a_demo"
              onClick={() =>
                document
                  .querySelector(".book_demo_container")
                  .classList.toggle("displayed_none")
              }
            >
              Book a Demo
            </button>
          </div>
          <div className="right">
            <div className="bg_img_container"></div>
            <div className="monitor_course_fees">
              <h3>Monitor Income & Expenses</h3>
              <p>
                <img
                  src="./new_landing_page_images/monitor_course_fees_icon.svg"
                  alt="monitor_course_fees"
                />
                <span>Secure Payment</span>
              </p>
            </div>
          </div>
        </div>
        <div className="slider_btn_container right_slider_btn_container">
          <button
            className="right_slider_btn"
            onClick={(e) => {
              e.target.parentElement.parentElement.parentElement
                .querySelector(".school_admin_module")
                .classList.toggle("displayed_none");
              e.target.parentElement.parentElement.parentElement
                .querySelector(".school_accounts_module")
                .classList.toggle("displayed_none");
            }}
          ></button>
        </div>
      </div>
      <div className="why_brainstake_eschools">
        <div className="for_students_parents_teachers_schools">
          <div className="left">
            {Object.keys(whyBrainstake).map((why, index) => (
              <ForStudentsParentsTeachersSchools
                key={index}
                icon_url={whyBrainstake[why].icon_url}
                heading={whyBrainstake[why].heading}
                content={whyBrainstake[why].content}
                make_green={whyBrainstake[why].make_green}
              />
            ))}
          </div>
          <div className="right">
            <div>
              <h3>Automated Financial Reports</h3>
              <img
                src={
                  "./new_landing_page_images/automated_financial_reports.png"
                }
                alt="Performance Monitor"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="features">
        {shownFeatures.length > 0 && (
          <div className="container">
            <div
              className="left"
              style={{
                transition: "opacity 0.3s ease-in-out",
                opacity: fade ? 1 : 0,
              }}
            >
              {shownFeatures
                .map((feature, index) => (
                  <Feature
                    key={index}
                    data_index={index}
                    heading={feature.heading}
                    content={feature.content}
                    img_url={feature.img_url}
                    shouldBackgroundImageBeOnBottom={index === 1}
                    bg={feature.bg}
                  />
                ))
                .filter((feature, index) => index !== 1)}
            </div>
            <div
              className="right"
              style={{
                transition: "opacity 0.3s ease-in-out",
                opacity: fade ? 1 : 0,
              }}
            >
              {shownFeatures
                .map((feature, index) => (
                  <Feature
                    key={index}
                    data_index={index}
                    heading={feature.heading}
                    content={feature.content}
                    img_url={feature.img_url}
                    shouldBackgroundImageBeOnBottom={index === 1}
                    bg={feature.bg}
                  />
                ))
                .filter((feature, index) => index === 1)}
            </div>
          </div>
        )}
      </div>
      <div className="learners_testimonials_container">
        <h2>What Our Learners Are Saying</h2>
        <div className="learners_testimonials">
          {learnersTestimonials.map(
            (
              {
                heading,
                content,
                testifier_name,
                testifier_role,
                media_type,
                media_url,
              },
              index
            ) => (
              <LearnerTestimonial
                key={index}
                heading={heading}
                content={content}
                testifier_name={testifier_name}
                testifier_role={testifier_role}
                media_type={media_type}
                media_url={media_url}
                index={index}
              />
            )
          )}
        </div>
      </div>
      <div className="get_in_touch">
        <div className="left">
          <div className="top">
            <div className="top_right">
              <HappyStudentsCollaboratedWith
                images={schools_collaborated_with_img_urls}
                heading={"Collaborated with"}
                message={"Top Rated e-Schools"}
                number={65}
              />
            </div>
            <div className="bottom_left">
              <p className="top">100+</p>
              <p className="bottom">e-learning Schools</p>
            </div>
          </div>
        </div>
        <div className="right" id="contact_us">
          <h2>Get in Touch</h2>
          <p>
            Have any question or feedback, feel free to reach out to us. We are
            always available to help.
          </p>
          <div className="form_fields">
            <FormField
              input_type={"text"}
              name={"full_name"}
              icon_url={"./new_landing_page_images/form_avatar.svg"}
              placeholder_text={"Enter your full name"}
              full_size={true}
              setPayloadGetInTouch={setPayloadGetInTouch}
              isGetInTouch={true}
              isValid={isNameValidGetInTouch}
            />
            <FormField
              input_type={"text"}
              name={"email"}
              icon_url={"./new_landing_page_images/form_envelope.svg"}
              placeholder_text={"Enter email ID"}
              full_size={false}
              setPayloadGetInTouch={setPayloadGetInTouch}
              isGetInTouch={true}
              isValid={isEmailValidGetInTouch}
            />
            <FormField
              input_type={"phone"}
              name={"phone_number"}
              icon_url={"./new_landing_page_images/form_phone.svg"}
              placeholder_text={"Enter Phone No"}
              full_size={false}
              setPayloadGetInTouch={setPayloadGetInTouch}
              isGetInTouch={true}
              isValid={isPhoneNumberValidGetInTouch}
            />
            <FormField
              input_type={"text"}
              name={"institution_name"}
              icon_url={"./new_landing_page_images/form_institution.svg"}
              placeholder_text={"Enter Institution name"}
              full_size={true}
              setPayloadGetInTouch={setPayloadGetInTouch}
              isGetInTouch={true}
              isValid={isInstitutionNameValidGetInTouch}
            />
            <FormField
              input_type={"select"}
              name={"role"}
              icon_url={"./new_landing_page_images/form_avatar_with_gear.svg"}
              placeholder_text={"Your Role"}
              full_size={true}
              roles={[
                "HEAD/PRINCIPAL",
                "INSTITUTION_OWNER",
                "DEPUTY_HEAD/PRINCIPAL",
                "DIRECTOR",
                "TEACHER",
                "PARENT",
                "STUDENT",
                "ANCILLARY",
              ]}
              setPayloadGetInTouch={setPayloadGetInTouch}
              isGetInTouch={true}
              isValid={isRoleValidGetInTouch}
            />
            <FormField
              input_type={"textarea"}
              name={"message"}
              icon_url={"./new_landing_page_images/form_speech_bubble.svg"}
              placeholder_text={"Share your thoughts..."}
              full_size={true}
              has_textarea={true}
              setPayloadGetInTouch={setPayloadGetInTouch}
              isGetInTouch={true}
              isValid={isMessageGetInTouch}
            />
            <button
              className="submit_get_in_touch"
              onClick={() => {
                if (!payloadGetInTouch?.full_name) {
                  setIsNameValidGetInTouch(false);
                  setTimeout(() => {
                    setIsNameValidGetInTouch(true);
                  }, 2000);
                  return;
                }
                if (!payloadGetInTouch?.email) {
                  setIsEmailValidGetInTouch(false);
                  setTimeout(() => {
                    setIsEmailValidGetInTouch(true);
                  }, 2000);
                  return;
                }
                if (
                  payloadGetInTouch?.email &&
                  !emailRegex(payloadGetInTouch?.email)
                ) {
                  setIsEmailValidGetInTouch(false);
                  setTimeout(() => {
                    setIsEmailValidGetInTouch(true);
                  }, 2000);
                  return;
                }
                if (!payloadGetInTouch?.phone_number) {
                  setIsPhoneNumberValidGetInTouch(false);
                  setTimeout(() => {
                    setIsPhoneNumberValidGetInTouch(true);
                  }, 2000);
                  return;
                }
                if (!payloadGetInTouch?.institution_name) {
                  setIsInstitutionNameValidGetInTouch(false);
                  setTimeout(() => {
                    setIsInstitutionNameValidGetInTouch(true);
                  }, 2000);
                  return;
                }
                if (!payloadGetInTouch?.role) {
                  setIsRoleValidGetInTouch(false);
                  setTimeout(() => {
                    setIsRoleValidGetInTouch(true);
                  }, 2000);
                  return;
                }
                if (!payloadGetInTouch?.message) {
                  setIsMessageGetInTouch(false);
                  setTimeout(() => {
                    setIsMessageGetInTouch(true);
                  }, 2000);
                  return;
                }
                getInTouch();
              }}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
      <Footer />
      <BookDemo />
    </div>
  );
};

export default NewLandingPage;
